import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../assets/css/Login.css";
import { toggleLoginScreen } from "../actions/AccountAction";
import Icon from "@identitybuilding/idb-react-iconlib";
import { OsnInputText } from "@identitybuilding/idb-react-ui-elements";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import Slider from "react-slick";
import { getEnvEndpoints } from "../utils/functions";

// function useForceUpdate() {
//     const [value, setValue] = useState(0); // integer state
//     return () => setValue(value => value + 1); // update state to force render
//     // An function that increment 👆🏻 the previous state like here
//     // is better than directly setting `value + 1`
// }

const Login = (props) => {
  // const forceUpdate = useForceUpdate();
  const { token } = useParams();

  const dispatch = useDispatch();
  const history = useHistory();
  const { translate, lang } = useSelector((state) => state.general);
  const [error, setError] = useState("");

  const [email, setEmail] = useState("");
  const [forgotPassword, setForgotPassword] = useState("");
  const [forgotRepeatPassword, setForgotRepeatPassword] = useState("");
  const [viewPassword, setViewPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [viewRepeatPassword, setViewRepeatPassword] = useState(false);
  const [errorField, setErrorField] = useState("");
  const env = getEnvEndpoints();
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    swipeToSlide: true,
  };

  const isUpper = (str) => {
    return /[A-Z]/.test(str);
  };
  const hasNumber = (str) => {
    return /[0-9]/.test(str);
  };

  const passwordResetHandler = () => {
    if (email === "") {
      props.createNotification("warning", translate("please_enter_an_email"));
      setError("email");
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      props.createNotification("warning", translate("not_a_valid_email"));
      setError("email");
    } else if (forgotPassword === "") {
      props.createNotification("warning", translate("please_enter_a_password"));
      setError("password");
    } else if (forgotPassword.length < 8) {
      props.createNotification("warning", translate("password_8_characters"));
      setError("password");
    } else if (!isUpper(forgotPassword)) {
      props.createNotification("warning", translate("password_1_capital"));
      setError("password");
    } else if (!hasNumber(forgotPassword)) {
      props.createNotification("warning", translate("password_1_number"));
      setError("password");
    } else if (forgotRepeatPassword === "") {
      props.createNotification("warning", translate("enter_password_repeat"));
      setError("repeat_password");
    } else if (forgotPassword !== forgotRepeatPassword) {
      props.createNotification("warning", translate("passwords_do_not_match"));
      setError("repeat_password");
    } else {
      axios
        .post(`${env.REACT_APP_BASE_MEDIA_URL}/core/api/stadgemeente/reset/`, {
          email: email,
          password: forgotPassword,
          repeat_password: forgotRepeatPassword,
          token: token,
        })
        .then((res) => {
          props.createNotification(
            "info",
            translate("password_successfully_changed")
          );
          history.push(`/`);
        });
    }
  };

  return (
    <div id="login_wrapper">
      <div className="login_content" style={{ height: "100vh" }}>
        <Icon
          className="close_icon"
          name="Close"
          onClick={() => dispatch(toggleLoginScreen(false))}
        />
        <figure>
          <img
            src={require(`../assets/imgs/logos/mijnstad-gemeente_${lang}.svg`).default}
            alt="logo"
          />
        </figure>
        {(() => {
          const welcomeMap = {
            nl: { text: "Welkom op", highlight: "Mijn Stad Gemeente" },
            fr: { text: "BIENVENUE DANS MA VILLE", highlight: "COMMUNE" },
            en: { text: "Welcome to", highlight: "City Municipality" },
            de: { text: "Willkommen bei", highlight: "Stadt Gemeinde" },
          };
          const w = welcomeMap[lang] || welcomeMap.nl;
          return (
            <h2>
              {w.text}{" "}
              <span style={{ color: "var(--cn)" }}>&nbsp;{w.highlight}</span>
            </h2>
          );
        })()}
        <div className="innerLogin">
          <div className="login">
            <OsnInputText
              error={errorField === "email"}
              className="email"
              icon="Mail"
              title={translate("email")}
              onChange={(e) => {
                setEmail(e.target.value);
                setErrorField("");
              }}
            />
            <div className="input-container">
              <span
                className="password-icon"
                style={{ marginTop: "5px" }}
                onClick={() => setViewPassword(!viewPassword)}
              >
                <Icon name={viewPassword ? "PasswordShow" : "PasswordHide"} />
              </span>
              <OsnInputText
                error={errorField === "password"}
                className="password"
                cta_icon={viewPassword ? "Hidden" : "Visible"}
                cta_click={() => setViewPassword(!viewPassword)}
                icon="Locked"
                title={translate("password")}
                type={viewPassword ? "text" : "password"}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setErrorField("");
                }}
              />
            </div>
            <div className="input-container">
              <span
                className="password-icon"
                style={{ marginTop: "5px" }}
                onClick={() => setViewRepeatPassword(!viewRepeatPassword)}
              >
                <Icon
                  name={viewRepeatPassword ? "PasswordShow" : "PasswordHide"}
                />
              </span>
              <OsnInputText
                error={errorField === "repeat_password"}
                className="password"
                cta_icon={viewRepeatPassword ? "Hidden" : "Visible"}
                cta_click={() => setViewRepeatPassword(!viewRepeatPassword)}
                icon="Locked"
                title={translate("repeat_password")}
                type={viewRepeatPassword ? "text" : "password"}
                onChange={(e) => {
                  setRepeatPassword(e.target.value);
                  setErrorField("");
                }}
              />
            </div>
            <div
              className="login_button"
              onClick={() => passwordResetHandler()}
            >
              {translate("reset_password")}
            </div>

            <div className="slider-container" style={{ maxHeight: "30vh" }}>
              {(() => {
                const sliderPrefixMap = {
                  nl: "Plenny__mijn.stad-gemeente",
                  fr: "Plenny_ma.ville-commune",
                  en: "Plenny__mijn.stad-gemeente",
                  de: "Plenny__mijn.stad-gemeente",
                };
                const prefix = sliderPrefixMap[lang] || sliderPrefixMap.nl;
                return (
                  <Slider {...sliderSettings}>
                    {[1, 2, 3, 4, 5].map((i) => (
                      <div key={i}>
                        <img src={`/SliderImages/${prefix}-${i}.svg`} alt={`i${i}`} />
                      </div>
                    ))}
                  </Slider>
                );
              })()}
            </div>
          </div>
        </div>
      </div>
      <div
        className="login_bg"
        onClick={() => dispatch(toggleLoginScreen(false))}
      ></div>
    </div>
  );
};

export default Login;
